import styles from './styles.module.css';
import { Button } from '../../components/Button';
import { ButtonBack } from '../../components/ButtonBack';
import { List, ListItem } from '../../components/List';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import logoOQ from '../../assets/images/logo-light.png';
import { useAuth } from '../../hooks/useAuth';
import { useEffect, useState } from 'react';
import { api } from '../../server/api';
import { toast } from 'react-toastify';
import moment from 'moment';
import { Loading } from '../../components/Loading';

export function Extract() {
  const { client, player } = useAuth();
  const [logoProgram, setLogoProgram] = useState('');
  const [clientLogo, setClientLogo] = useState('');
  const [listExtract, setListExtract] = useState([]);
  const [extract, setExtract] = useState();
  const [leads, setLeads] = useState([]);
  const [inputValue, setInputValue] = useState('0');
  const [outputValue, setOutputValue] = useState('0');
  const [actualPage, setActualPage] = useState(1);
  const [isVisibleButtonViewMore, setIsVisibleButtonViewMore] = useState(true);
  const [loadingListExtract, setLoadingListExtract] = useState(true);

  useEffect(() => {
    initialHandles();
    getMyIndications();
  }, []);

  async function initialHandles() {
    const image: any = await convertImageToBase64(client && client.logoURL);
    const image2: any = await convertImageToBase64(
      client && client.originalLogoClient
    );
    setLogoProgram(image);
    setClientLogo(image2);
    getListExtract(actualPage);
  }

  async function getListExtract(page: number) {
    try {
      setLoadingListExtract(true);
      const response = await api.get(
        `/statement/${player && player.id}?currentPage=${page}`
      );

      if (!response.data.body.error) {
        toast.success('Extrato obtido com sucesso.');
        setListExtract(response.data.body.statementTransactions);
        if (response.data.body.totalTransactionsValues) {
          setInputValue(response.data.body.totalTransactionsValues.input);
          setOutputValue(response.data.body.totalTransactionsValues.output);
        }
        if (
          response.data.body.pagination.currentPage ===
          response.data.body.pagination.totalPages
        ) {
          setIsVisibleButtonViewMore(!isVisibleButtonViewMore);
        }
      } else {
        toast.error('Não foi possível buscar o extrato.');
      }
    } catch (error) {
      console.log('Error getListExtract: ', error);
    } finally {
      setLoadingListExtract(false);
    }
  }

  const getMyIndications = async () => {
    try {
      const parameters = {
        searchFunctionality: 'getMyIndications',
        userType: 'player',
        statusFilter: '',
        client: client,
        isInfluencer: null,
      };

      const { data } = await api.post('/search', parameters);
      if (data.success) {
        setLeads(data.data);
      }
    } catch (error) {
      console.log('getMyIndications eror: ', error);
    }
  };

  async function getExtract(id: string) {
    try {
      const response = await api.get(`/receipt/${id}`);

      if (!response.data.body.error) {
        toast.success('Comprovante obtido com sucesso.');
        setExtract(response.data.body.transaction);
      } else {
        toast.error('Não foi possível buscar o comprovante.');
      }
    } catch (error) {
      console.log('Error getExtract: ', error);
    }
  }

  const generatePDF = (id: string) => {
    const postPrintElement: HTMLElement | null = document.querySelector(id);

    if (postPrintElement) {
      html2canvas(postPrintElement, {
        scale: 4,
      }).then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const doc = new jsPDF('p', 'mm', 'a4', true);
        const width = doc.internal.pageSize.getWidth();
        const height = doc.internal.pageSize.getHeight();
        doc.addImage(imgData, 'PNG', 0, 0, width, height);
        doc.save(`comprovante-${Date.now()}.pdf`);
      });
    }
  };

  async function convertImageToBase64(imageUrl: string) {
    try {
      // Fetch the image from the URL
      const response = await fetch(imageUrl);
      const blob = await response.blob();

      // Convert the blob to a Base64 string
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error('Error convertImageToBase64:', error);
      throw error;
    }
  }

  function findBrokerStep(item) {
    const foundStep = client.brokerSteps.find(
      (step: { externalId: string; name: string }) => {
        if (
          step.externalId === item.metadata?.stepId?.toString() ||
          step.externalId === item.metadata?.brokerStep?.externalId
        )
          return step;
      }
    );
    const itemName = foundStep?.name || '';
    const leadName = leads.find((lead) => {
      if (
        lead.idCustomer === item.metadata?.leadId ||
        lead.idCustomer === item.metadata?.brokerStep?.leadId
      )
        return lead.name;
    });

    return itemName && leadName
      ? `${itemName} - Lead: ${leadName}`
      : `${itemName} - Lead: ${item.metadata?.leadId ? item.metadata?.leadId : item.metadata?.brokerStep?.leadId}`;
  }

  return (
    <>
      {loadingListExtract && <Loading />}
      {!loadingListExtract && (
        <div className="container">
          <div className="row">
            <div className="my-3">
              <div className="d-flex justify-content-between">
                <div>
                  <ButtonBack title="Extrato" />
                </div>
                <div>
                  {client && client.clientUrl === 'meuvivaz' && (
                    <div className="d-flex align-items-center gap-2">
                      <Button
                        text="10.000"
                        icon="arrow_upward"
                        color="success"
                      />
                      <Button
                        text="6.000"
                        icon="arrow_downward"
                        color="danger"
                      />
                    </div>
                  )}
                  {(client?.clientUrl === 'md' ||
                    client?.clientUrl === 'aceleramd' ||
                    client?.clientUrl === 'pride' ||
                    client?.clientUrl === 'vivazvendas') && (
                    <div className="d-flex align-items-center gap-2">
                      <Button
                        text={Number(inputValue).toFixed(2)}
                        icon="arrow_upward"
                        color="success"
                      />
                      <Button
                        text={Number(outputValue).toFixed(2)}
                        icon="arrow_downward"
                        color="danger"
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              {client && client.clientUrl === 'meuvivaz' && (
                <List>
                  <ListItem
                    icon="arrow_downward"
                    colorIcon="var(--danger)"
                    content={
                      <>
                        <div>
                          <p className="m-0 tiny-text">Pagamento via: PIX</p>
                          <p className="m-0 fw-semibold fs-5">R$ 6.000</p>
                          <p className="m-0 tiny-text">29/08/2024</p>
                        </div>
                      </>
                    }
                    secondaryContent={
                      <>
                        <Button
                          text="6.000"
                          icon="arrow_downward"
                          color="danger"
                        />
                        <div className="ms-2">
                          <Button
                            text=""
                            icon="file_download"
                            data-bs-toggle="modal"
                            data-bs-target="#modal-output"
                          />
                        </div>
                      </>
                    }
                  />
                  <ListItem
                    icon="arrow_upward"
                    colorIcon="rgb(0, 150, 0)"
                    content={
                      <>
                        <div>
                          <p className="m-0 tiny-text">
                            Novo Irajá - Rio de Janeiro
                          </p>
                          <p className="m-0 fw-semibold fs-5">R$ 2.000</p>
                          <p className="m-0 tiny-text">28/08/2024</p>
                        </div>
                      </>
                    }
                    secondaryContent={
                      <>
                        <Button
                          text="2.000"
                          icon="arrow_upward"
                          color="success"
                        />
                        <div className="ms-2">
                          <Button
                            text=""
                            icon="file_download"
                            data-bs-toggle="modal"
                            data-bs-target="#modal-input"
                          />
                        </div>
                      </>
                    }
                  />
                  <ListItem
                    icon="arrow_upward"
                    colorIcon="rgb(0, 150, 0)"
                    content={
                      <>
                        <div>
                          <p className="m-0 tiny-text">
                            Novo Irajá - Rio de Janeiro
                          </p>
                          <p className="m-0 fw-semibold fs-5">R$ 2.000</p>
                          <p className="m-0 tiny-text">26/08/2024</p>
                        </div>
                      </>
                    }
                    secondaryContent={
                      <>
                        <Button
                          text="2.000"
                          icon="arrow_upward"
                          color="success"
                        />
                        <div className="ms-2">
                          <Button
                            text=""
                            icon="file_download"
                            data-bs-toggle="modal"
                            data-bs-target="#modal-input"
                          />
                        </div>
                      </>
                    }
                  />
                  <ListItem
                    icon="arrow_upward"
                    colorIcon="rgb(0, 150, 0)"
                    content={
                      <>
                        <div>
                          <p className="m-0 tiny-text">
                            Novo Irajá - Rio de Janeiro
                          </p>
                          <p className="m-0 fw-semibold fs-5">R$ 2.000</p>
                          <p className="m-0 tiny-text">22/08/2024</p>
                        </div>
                      </>
                    }
                    secondaryContent={
                      <>
                        <Button
                          text="2.000"
                          icon="arrow_upward"
                          color="success"
                        />
                        <div className="ms-2">
                          <Button
                            text=""
                            icon="file_download"
                            data-bs-toggle="modal"
                            data-bs-target="#modal-input"
                          />
                        </div>
                      </>
                    }
                  />
                  <ListItem
                    icon="arrow_upward"
                    colorIcon="rgb(0, 150, 0)"
                    content={
                      <>
                        <div>
                          <p className="m-0 tiny-text">
                            Novo Irajá - Rio de Janeiro
                          </p>
                          <p className="m-0 fw-semibold fs-5">R$ 2.000</p>
                          <p className="m-0 tiny-text">16/08/2024</p>
                        </div>
                      </>
                    }
                    secondaryContent={
                      <>
                        <Button
                          text="2.000"
                          icon="arrow_upward"
                          color="success"
                        />
                        <div className="ms-2">
                          <Button
                            text=""
                            icon="file_download"
                            data-bs-toggle="modal"
                            data-bs-target="#modal-input"
                          />
                        </div>
                      </>
                    }
                  />
                  <ListItem
                    icon="arrow_upward"
                    colorIcon="rgb(0, 150, 0)"
                    content={
                      <>
                        <div>
                          <p className="m-0 tiny-text">
                            Novo Irajá - Rio de Janeiro
                          </p>
                          <p className="m-0 fw-semibold fs-5">R$ 2.000</p>
                          <p className="m-0 tiny-text">13/08/2024</p>
                        </div>
                      </>
                    }
                    secondaryContent={
                      <>
                        <Button
                          text="2.000"
                          icon="arrow_upward"
                          color="success"
                        />
                        <div className="ms-2">
                          <Button
                            text=""
                            icon="file_download"
                            data-bs-toggle="modal"
                            data-bs-target="#modal-input"
                          />
                        </div>
                      </>
                    }
                  />
                </List>
              )}
              {(client?.clientUrl === 'md' ||
                client?.clientUrl === 'aceleramd' ||
                client?.clientUrl === 'pride' ||
                client?.clientUrl === 'vivazvendas') && (
                <>
                  <List>
                    {listExtract &&
                      listExtract.length > 0 &&
                      listExtract.map((item) => (
                        <ListItem
                          icon={
                            item.type === 'INPUT'
                              ? 'arrow_upward'
                              : 'arrow_downward'
                          }
                          colorIcon={
                            item.type === 'INPUT'
                              ? 'rgb(0, 150, 0)'
                              : 'var(--danger)'
                          }
                          content={
                            <>
                              {item.type === 'OUTPUT' && (
                                <div>
                                  <p className="m-0 tiny-text">
                                    Tipo de resgate
                                  </p>
                                  <p className="m-0 fw-semibold fs-5">
                                    {item.redeemMethod}
                                  </p>
                                  <p className="m-0 tiny-text">
                                    {moment(item.transactionDate).format(
                                      'DD/MM/YYYY'
                                    )}
                                  </p>
                                </div>
                              )}
                              {item.type === 'INPUT' && (
                                <div>
                                  <p className="m-0 tiny-text">
                                    {item.metadata?.building
                                      ? item.metadata?.building
                                      : item.pointsOrigin ===
                                            'BROKER_WEBHOOK' &&
                                          client?.brokerSteps
                                        ? findBrokerStep(item)
                                        : item.pointsOrigin}
                                    {item.metadata?.building &&
                                      item.metadata?.unit &&
                                      ` - ${item.metadata?.unit}`}
                                    {item.metadata?.building &&
                                      item.metadata?.bl &&
                                      ` - ${item.metadata?.bl}`}
                                  </p>
                                  <p className="m-0 fw-semibold fs-5">
                                    {item.vgv &&
                                      item.vgv.toLocaleString('pt-BR', {
                                        style: 'currency',
                                        currency: 'BRL',
                                      })}
                                  </p>
                                  <p className="m-0 tiny-text">
                                    {moment(item.transactionDate).format(
                                      'DD/MM/YYYY'
                                    )}
                                  </p>
                                </div>
                              )}
                            </>
                          }
                          secondaryContent={
                            <>
                              <Button
                                text={`${Number(item.value).toFixed(2)}`}
                                icon={
                                  item.type === 'INPUT'
                                    ? 'arrow_upward'
                                    : 'arrow_downward'
                                }
                                color={
                                  item.type === 'INPUT' ? 'success' : 'danger'
                                }
                              />
                              <div className="ms-2">
                                <Button
                                  text=""
                                  icon="file_download"
                                  data-bs-toggle="modal"
                                  data-bs-target={
                                    item.type === 'INPUT'
                                      ? '#modal-input'
                                      : '#modal-output'
                                  }
                                  onClick={() => getExtract(item.transactionId)}
                                />
                              </div>
                            </>
                          }
                        />
                      ))}
                  </List>
                  {isVisibleButtonViewMore &&
                    listExtract &&
                    listExtract.length > 0 && (
                      <div className="mt-4">
                        <div className="d-flex justify-content-center">
                          <Button
                            text="Ver mais"
                            color="flat"
                            icon="add"
                            onClick={() => {
                              getListExtract(actualPage + 1);
                              setActualPage(actualPage + 1);
                            }}
                          />
                        </div>
                      </div>
                    )}
                </>
              )}
              {client &&
                client.clientUrl !== 'meuvivaz' &&
                listExtract &&
                listExtract.length === 0 && (
                  <>
                    <div className="alert alert-primary" role="alert">
                      Não há histórico de extratos disponíveis ainda.
                    </div>
                  </>
                )}
            </div>
          </div>
          <div
            className="modal fade"
            id="modal-input"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel">
                    Comprovante
                  </h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  <div className={styles.boxComprovante}>
                    <div className={styles.comprovante} id="print">
                      <div className="d-flex align-items-center justify-content-center gap-3 m-0">
                        <img src={clientLogo} style={{ width: 70 }} alt="" />
                        <img src={logoProgram} style={{ width: 70 }} alt="" />
                      </div>
                      <p className="my-3 fw-semibold">Emitente</p>
                      <p className="m-0">
                        Nome: {client && client.companyName} / OQ Digital
                      </p>
                      <p className="m-0">
                        CNPJ: {client && client.companyInscription}
                      </p>
                      <p className="m-0">
                        Contato: {client && client.contactEmail}
                      </p>
                      <p className="my-3 fw-semibold">Destinatário</p>
                      <p className="m-0">Nome: {player && player.name}</p>
                      <p className="m-0">CPF/CNPJ: {player && player.cpf}</p>
                      <p className="m-0">Contato: {player && player.email}</p>
                      <p className="my-3 fw-semibold">Transação</p>
                      <p className="m-0">
                        Número comprovante: {extract && (extract as any).id}
                      </p>
                      <p className="m-0">
                        Ref:{' '}
                        {moment(
                          extract && (extract as any).creationDate
                        ).format('DD/MM/YY')}
                      </p>
                      <p className="my-3 fw-semibold">Resumo</p>
                      {client.clientUrl === 'pride' ? (
                        <p className="m-0">
                          Id do Lead:{' '}
                          {extract && (extract as any).metadata?.leadId}
                        </p>
                      ) : (
                        <p className="m-0">
                          VGV:{' '}
                          {extract &&
                            (extract as any).metadata?.vgv.toLocaleString(
                              'pt-BR',
                              {
                                style: 'currency',
                                currency: 'BRL',
                              }
                            )}
                        </p>
                      )}
                      {(extract as any)?.metadata?.building && (
                        <p className="m-0">
                          Empreendimento:{' '}
                          {`${(extract as any)?.metadata?.building}`}
                          {(extract as any)?.metadata?.building &&
                            (extract as any)?.metadata?.unit &&
                            ` - ${(extract as any)?.metadata?.unit}`}
                          {(extract as any)?.metadata?.building &&
                            (extract as any)?.metadata?.bl &&
                            ` - ${(extract as any)?.metadata?.bl}`}
                        </p>
                      )}
                      {(extract as any)?.metadata?.cnpj && (
                        <p className="m-0">
                          SPE: {`${(extract as any)?.metadata?.cnpj}`}
                        </p>
                      )}
                      <p className="m-0">
                        Valor recebido:{' '}
                        {extract && (extract as any).value.toFixed(2)}
                      </p>
                      <div className="text-center mt-5">
                        <img src={logoOQ} style={{ width: 40 }} alt="" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Fechar
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => {
                      generatePDF('#print');
                    }}
                  >
                    Baixar
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            className="modal fade"
            id="modal-output"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel">
                    Comprovante
                  </h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  <div className={styles.boxComprovante}>
                    <div className={styles.comprovante} id="print-2">
                      <div className="d-flex align-items-center justify-content-center gap-3 m-0">
                        {/* <img src={logoOQ} style={{ width: 40 }} alt="" /> */}
                        <img src={clientLogo} style={{ width: 70 }} alt="" />
                        <img src={logoProgram} style={{ width: 70 }} alt="" />
                      </div>
                      <p className="my-3 fw-semibold">Emitente</p>
                      <p className="m-0">
                        Nome: {client && client.companyName} / OQ Digital
                      </p>
                      <p className="m-0">
                        CNPJ: {client && client.companyInscription}
                      </p>
                      <p className="m-0">
                        Contato: {client && client.contactEmail}
                      </p>
                      <p className="my-3 fw-semibold">Destinatário</p>
                      <p className="m-0">Nome: {player && player.name}</p>
                      <p className="m-0">CPF/CNPJ: {player && player.cpf}</p>
                      <p className="m-0">Contato: {player && player.email}</p>
                      <p className="my-3 fw-semibold">Transação</p>
                      <p className="m-0">
                        Método de pagamento:{' '}
                        {extract && (extract as any).metadata?.paymentMethod}
                      </p>
                      <p className="m-0">
                        Número comprovante: {extract && (extract as any).id}
                      </p>
                      <p className="m-0">
                        Ref:{' '}
                        {moment(
                          extract && (extract as any).creationDate
                        ).format('DD/MM/YY')}
                      </p>
                      <p className="my-3 fw-semibold">Resumo</p>
                      <p className="m-0">
                        Valor retirado:{' '}
                        {extract && (extract as any).value.toFixed(2)}
                      </p>
                      <div className="text-center mt-5">
                        <img src={logoOQ} style={{ width: 40 }} alt="" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Fechar
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => {
                      generatePDF('#print-2');
                    }}
                  >
                    Baixar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
